interface IBullets {
	bullets: Array<string>
}

const BulletMap: React.FC<IBullets> = ({ bullets }) => {
	const result = bullets.map((el, idx: number) => <li key={idx}>{el}</li>);
	return <ul>{result}</ul>;
};

export default BulletMap;